import script from "./ElementColorMask.vue?vue&type=script&lang=ts&setup=true"
export * from "./ElementColorMask.vue?vue&type=script&lang=ts&setup=true"

import "./ElementColorMask.vue?vue&type=style&index=0&id=f466867c&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f466867c"]])

export default __exports__